module.exports = __webpack_public_path__ + "img/datetime.de05a53d.png";